import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let BcTable = class BcTable extends Vue {
    constructor() {
        super(...arguments);
        this.options = {};
    }
    /**
     * 后端返回值格式不同兼容
     * {'lg.zw':1} or {lg:{zw:1}}
     */
    getItemValue(rowData, header) {
        if (Object.keys(rowData).indexOf(header.value) > -1) {
            return rowData[header.value];
        }
        const value = header.value.split('.');
        value.forEach((o) => {
            rowData = rowData[o] || '';
        });
        return rowData;
    }
    // 升序事件
    sortBy(values) { }
    // 降序事件
    sortDesc(values) {
        // console.log(234, this.options.sortBy[0], this.options.sortDesc[0]);
        if (this.options.sortBy[0]) {
            this.$emit('tableSort', {
                prop: this.options.sortBy[0],
                type: this.options.sortDesc[0] ? 'desc' : 'asc',
            });
        }
    }
};
__decorate([
    Prop()
], BcTable.prototype, "props", void 0);
BcTable = __decorate([
    Component({
        name: 'BcTable',
    })
], BcTable);
export default BcTable;
